export default "__VITE_ASSET__CHvy8gL2__"